// extracted by mini-css-extract-plugin
export default {"container":"a8-z","heading":"b8-z","links":"c8-z","linkBtn":"d8-z","disabled":"e8-z","linkUppercaseBold":"f8-z","copy":"g8-z","subCopy":"h8-z"};